import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export type ThemeMode = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'assessor:theme';

/** Tema e estado de chrome da interface. */
export const useUiStore = defineStore('ui', () => {
  const theme = ref<ThemeMode>((localStorage.getItem(STORAGE_KEY) as ThemeMode) || 'system');
  const sidebarCollapsed = ref(localStorage.getItem('assessor:sidebar') === '1');

  function applyTheme(): void {
    const root = document.documentElement;
    if (theme.value === 'system') {
      root.removeAttribute('data-theme');
    } else {
      root.setAttribute('data-theme', theme.value);
    }
  }

  function setTheme(mode: ThemeMode): void {
    theme.value = mode;
    localStorage.setItem(STORAGE_KEY, mode);
    applyTheme();
  }

  function toggleSidebar(): void {
    sidebarCollapsed.value = !sidebarCollapsed.value;
    localStorage.setItem('assessor:sidebar', sidebarCollapsed.value ? '1' : '0');
  }

  watch(theme, applyTheme, { immediate: true });

  return { theme, sidebarCollapsed, setTheme, toggleSidebar, applyTheme };
});
